import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Autocomplete,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Chip,
  Alert,
  Divider,
  Paper,
} from "@mui/material";
import { Formik, FieldArray } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import {
  companyManagementUrl,
  inventoryManagementUrl,
  salesManagement,
  setupManagementUrl,
} from "../../../config";
import {
  AllProducts,
  AllVendors,
  allCompanyBranchesView,
  UOMQuery,
  AllPurchaseOrdersView,
  AllPurchaseOrderItems,
  AllWarehouseInventory,
  SizeQuery,
  AllInventoryView
} from "../../../data/Axios/queries";
import axios from "axios";
const createOrder_base_url = salesManagement.uri;
const PurchaseOrderForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken") || "{}");
 const tokenBranchId = parseInt(decodedToken?.BranchId) || null;
 const isBranchUser = !!tokenBranchId;

  const getTodayLocalDate = () => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  };
  const [productData, setProductData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [sizeData, setSizeData] = useState([]);
  const [branchData, setBranch] = useState([]);
  const [uomData, setUomData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [purchaseOrdersData, setPurchaseOrdersData] = useState([]);
  const [warehouseInventory, setWarehouseInventory] = useState([]);
  const [productCodeToVendorMap, setProductCodeToVendorMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [orderMode, setOrderMode] = useState(isBranchUser ? "retail" : "warehouse");  const [CartonsUomId, setCartonsUomId] = useState(0);
  const [isInternalWarehouse, setIsInternalWarehouse] = useState(false);
  const [globalSource, setGlobalSource] = useState("");
  const [globalVendor, setGlobalVendor] = useState("");
  const [globalVendorComments, setGlobalVendorComments] = useState("");
  const [allInventory, setAllInventory] = useState([]);
  const [purchaseOrderItemsData, setPurchaseOrderItemsData] = useState([]);

  const formikRef = useRef(null);


  // Add this useEffect to sync global selections:
  useEffect(() => {
    if (formikRef.current && formikRef.current.values.purchaseOrderItems) {
      const currentItems = formikRef.current.values.purchaseOrderItems;

      currentItems.forEach((_, index) => {
        // Sync source (vendorBranchId) for retail mode
        if (orderMode === "retail" && globalSource) {
          formikRef.current.setFieldValue(`purchaseOrderItems.${index}.vendorBranchId`, globalSource);
        }

        // Sync vendor for all modes
        if (globalVendor) {
          formikRef.current.setFieldValue(`purchaseOrderItems.${index}.vendorId`, globalVendor);
        }

        // Sync vendor comments for all items
        if (globalVendorComments !== undefined) {
          formikRef.current.setFieldValue(`purchaseOrderItems.${index}.vendorComments`, globalVendorComments);
        }
      });
    }
  }, [globalSource, globalVendor, globalVendorComments, orderMode, formikRef.current?.values.purchaseOrderItems?.length]);

  // Fetch colors
  const fetchColorsWithAxios = async () => {
    try {
      const rawToken = localStorage.getItem("token");
      const cleanToken = rawToken ? rawToken.replace(/^"|"$/g, "") : "";
      const response = await axios.post(
        setupManagementUrl.uri,
        {
          query: `query Color { color { id name isActive } }`,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cleanToken}`,
          },
        }
      );
      if (response.data.errors) throw new Error(response.data.errors[0].message);
      return response.data.data.color;
    } catch (error) {
      console.error("Error fetching colors:", error);
      throw error;
    }
  };
  const getUomNameById = (uomId) => {
    const uom = uomData.find(u => u.id === uomId);
    return uom ? uom.name.toLowerCase() : '';
  };
  // Fetch all data
  useEffect(() => {
    async function fetchAllData() {
      try {
        setLoading(true);
        const [
          productsRes,
          vendorsRes,
          branchesRes,
          uomsRes,
          colorsRes,
          purchaseOrdersRes,
          purchaseOrderItemsRes,
          warehouseInventoryRes,
          sizeRes,
          allInventoryRes,
        ] = await Promise.all([
          graphqlQuery(AllProducts, setupManagementUrl.uri),
          graphqlQuery(AllVendors, createOrder_base_url),
          graphqlQuery(allCompanyBranchesView, companyManagementUrl.uri),
          graphqlQuery(UOMQuery, setupManagementUrl.uri),
          fetchColorsWithAxios(),
          graphqlQuery(AllPurchaseOrdersView, createOrder_base_url),
          graphqlQuery(AllPurchaseOrderItems, createOrder_base_url),
          graphqlQuery(AllWarehouseInventory, createOrder_base_url),
          graphqlQuery(SizeQuery, setupManagementUrl.uri),
          graphqlQuery(AllInventoryView, inventoryManagementUrl.uri), // Add this

        ]);

        if (Array.isArray(productsRes)) {
          setProductData(productsRes.filter((p) => p.isInventory) && productsRes.filter((p) => p.isService === null || p.isService === 0));
        }
        if (Array.isArray(allInventoryRes)) {
          setAllInventory(allInventoryRes); // Add this state
        }
        if (vendorsRes) setVendorData(vendorsRes);
        if (Array.isArray(branchesRes)) setBranch(branchesRes);
        if (Array.isArray(uomsRes)) {
          setUomData(uomsRes);
          const cartonsUom = uomsRes.find(uom => uom.name.toLowerCase() === 'cartons' || uom.unit.toLowerCase() === 'cartons');
          if (cartonsUom) {
            // setCartonsUomId(cartonsUom.id);
          } else {
            console.warn("UOM 'Cartons' not found. Please ensure it exists in the system for Retail POs.");
          }
        }
        if (Array.isArray(colorsRes)) setColorData(colorsRes);
        if (Array.isArray(sizeRes)) setSizeData(sizeRes);
        if (Array.isArray(purchaseOrdersRes)) setPurchaseOrdersData(purchaseOrdersRes);

        // Build vendor lookup
        const vendorLookup = {};
        if (Array.isArray(purchaseOrderItemsRes)) {
          setPurchaseOrderItemsData(purchaseOrderItemsRes);
          const sortedItems = [...purchaseOrderItemsRes].sort((a, b) => {
            const dateA = a.orderDate ? new Date(a.orderDate) : new Date(0);
            const dateB = b.orderDate ? new Date(b.orderDate) : new Date(0);
            return dateB - dateA;
          });
          sortedItems.forEach((item) => {
            if (item.productCode && item.vendorId && !vendorLookup[item.productCode]) {
              vendorLookup[item.productCode] = item.vendorId;
            }
          });
          setProductCodeToVendorMap(vendorLookup);
        }
        if (Array.isArray(warehouseInventoryRes)) {
          setWarehouseInventory(warehouseInventoryRes);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire("Error", "Failed to load required data.", "error");
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);
   // Prepare options
  const productOptions = productData.map((p) => ({
    value: p.id,
    label: p.productName,
    productCode: p.productCode,
  }));
  const vendorOptions = vendorData.map((v) => ({
    value: v.id,
    label: v.vendorName,
    isInternal: v.isInternal,
  }));
  const branchOptions = branchData.map((b) => ({
    value: b.id,
    label: b.branchName,
    isWarehouse: Number(b.isWarehouse) === 1,
  }));
  const uomOptions = uomData.map((u) => ({
    value: u.id,
    label: `${u.name} (${u.unit})`,
  }));
  const colorOptions = colorData.map((c) => ({
    value: c.id,
    label: c.name,
  }));
  // Add this useEffect to handle token branch ID locking
  useEffect(() => {
    if (tokenBranchId && formikRef.current) {
      const availableBranchOptionsForMode = branchOptions.filter((b) => {
        if (orderMode === "warehouse") {
          return b.isWarehouse;
        } else {
          const name = b.label.toLowerCase();
          return (
            !b.isWarehouse &&
            !name.includes("external") &&
            !name.includes("outsource")
          );
        }
      });
      
      const isValidBranch = availableBranchOptionsForMode.some(opt => opt.value === tokenBranchId);
      if (isValidBranch) {
        formikRef.current.setFieldValue("branchId", tokenBranchId);
      } else {
        console.warn(`Token branch ${tokenBranchId} is not valid for ${orderMode} mode`);
        formikRef.current.setFieldValue("branchId", "");
      }
    }
  }, [orderMode, tokenBranchId, branchOptions]);
 

  // Validation schema
  const getValidationSchema = (mode) => {
    return yup.object().shape({
      globalVendor: mode === "warehouse" || mode === "retail"
        ? yup.number().required("Global vendor selection is required")
        : yup.number().notRequired(),
      globalSource: mode === "retail"
        ? yup.number().required("Global source selection is required for retail orders")
        : yup.number().notRequired(),
      purchaseOrderItems: yup
        .array()
        .of(
          yup.object().shape({
            productId: yup.number().required("Product is required"),
            productCode: yup.string().required("Product Code is required"),
            cartons: yup
              .number()
              .required("Cartons required")
              .positive("Must be positive")
              .integer("Must be whole number")
              .test(
                'max-cartons',
                'Cannot exceed available cartons',
                function (value) {
                  // Only validate carton limits when:
                  // 1. In retail mode AND
                  // 2. Source is a warehouse (cartonsAvailable is defined) AND  
                  // 3. cartonsAvailable is not undefined
                  if (mode === "retail" && isInternalWarehouse) {
                    const { cartonsAvailable } = this.parent;
                    if (cartonsAvailable !== undefined && value > cartonsAvailable) {
                      return this.createError({ message: `Only ${cartonsAvailable} cartons available` });
                    }
                  }
                  return true;
                }
              ),
            quantityPerCarton: yup
              .number()
              .required("Quantity required")
              .positive("Must be positive")
              .integer("Must be whole number"),
            buyingPricePerCarton: mode === "warehouse"
              ? yup.number().required("Buying price required").min(0, "Cannot be negative")
              : yup.number().notRequired(),
            sellingPricePerCarton: mode === "warehouse"
              ? yup.number().required("Selling price required").min(0, "Cannot be negative")
              : yup.number().notRequired(),
            buyingPricePerPair: mode === "retail"
              ? yup.number().required("Buying price per pair required").min(0, "Cannot be negative")
              : yup.number().notRequired(),
            sellingPricePerPair: mode === "retail"
              ? yup.number().required("Selling price per pair required").min(0, "Cannot be negative")
              : yup.number().notRequired(),
            reorderPoint: yup
              .number()
              .required("Reorder point required")
              .min(0, "Cannot be negative"),
            stockDueDate: yup
              .date()
              .required("Due date required")
              .min(new Date(), "Cannot be in the past"),
            createdDate: yup
              .date()
              .max(new Date(), "Cannot be in the future"),
               stockDueDate: yup
            .date()
            .required("Stock due date is required")
            .min(yup.ref('createdDate'), "Stock due date must be after purchase date")
            .test('min-one-week', 'Stock due date must be at least 7 days after purchase date', function(value) {
              const { createdDate } = this.parent;
              if (!createdDate || !value) return true;
              
              const purchaseDate = new Date(createdDate);
              const dueDate = new Date(value);
              const diffTime = dueDate - purchaseDate;
              const diffDays = diffTime / (1000 * 60 * 60 * 24);
              
              return diffDays >= 7;
            }),
            uomId: yup.number().required("UOM is required"),
            productAliasName: mode === "warehouse"
              ? yup.string().required("Product alias name is required for warehouse orders")
              : yup.string().notRequired(),
            minShoeSize: yup
              .string()
              .test('valid-size', 'Size does not exist in system', function (value) {
                if (!value || !sizeData || sizeData.length === 0) return true;
                const sizeExists = sizeData.some(size => size.name === value.toString());
                return sizeExists;
              }),
            maxShoeSize: yup
              .string()
              .test('valid-size', 'Size does not exist in system', function (value) {
                if (!value || !sizeData || sizeData.length === 0) return true;
                const sizeExists = sizeData.some(size => size.name === value.toString());
                return sizeExists;
              })
              .test('size-comparison', 'Max size must be greater than or equal to min size', function (value) {
                const { minShoeSize } = this.parent;
                if (!minShoeSize || !value) return true;
                const min = parseFloat(minShoeSize);
                const max = parseFloat(value);
                return max >= min;
              }),
          })
        )
        .min(1, "Add at least one item"),
    });
  };

  // Conditional validation
  // const validateFormConditional = (values) => {
  //   const errors = {};
  //   const selectedBranch = branchData.find((b) => b.id === values.branchId);
  //   const isWarehouse = selectedBranch ? Number(selectedBranch.isWarehouse) === 1 : false;

  //   if (values.purchaseOrderItems && Array.isArray(values.purchaseOrderItems)) {
  //     const itemsErrors = [];

  //     values.purchaseOrderItems.forEach((item, index) => {
  //       const itemErrors = {};

  //       // Retail-specific validations
  //       if (orderMode === "retail") {
  //         if (!item.vendorBranchId) {
  //           itemErrors.vendorBranchId = "Source warehouse required";
  //         }

  //         // Validate cartons not exceeding warehouse stock
  //         if (item.cartonsAvailable !== undefined && item.cartons) {
  //           const available = Number(item.cartonsAvailable);
  //           const requested = Number(item.cartons);
  //           if (requested > available) {
  //             itemErrors.cartons = `Only ${available} cartons available`;
  //           }
  //         }

  //         // Additional validation for cartons > 0 when cartonsAvailable is 0
  //         if (item.cartonsAvailable === 0 && item.cartons > 0) {
  //           itemErrors.cartons = "No cartons available";
  //         }
  //       }

  //       // Warehouse-specific validations
  //       if (isWarehouse) {

  //         if (item.minShoeSize === undefined || item.minShoeSize === "") {
  //           itemErrors.minShoeSize = "Min size required";
  //         }
  //         if (item.maxShoeSize === undefined || item.maxShoeSize === "") {
  //           itemErrors.maxShoeSize = "Max size required";
  //         } else if (item.minShoeSize !== undefined && Number(item.maxShoeSize) < Number(item.minShoeSize)) {
  //           itemErrors.maxShoeSize = "Max must be ≥ min";
  //         }
  //       }

  //       if (Object.keys(itemErrors).length > 0) {
  //         itemsErrors[index] = itemErrors;
  //       }
  //     });

  //     if (itemsErrors.length > 0) {
  //       errors.purchaseOrderItems = itemsErrors;
  //     }
  //   }
  //   return errors;
  // };
  // Add this helper function to get available sizes for validation messages
  const getAvailableSizes = () => { if (!sizeData || sizeData.length === 0) return []; return sizeData.map(size => size.name).sort((a, b) => parseInt(a) - parseInt(b)); };

  const availableSizes = getAvailableSizes();

  // Conditional validation
  const validateFormConditional = (values) => {
    const errors = {};
    const selectedBranch = branchData.find((b) => b.id === values.branchId);
    const isWarehouse = selectedBranch ? Number(selectedBranch.isWarehouse) === 1 : false;

    if (values.purchaseOrderItems && Array.isArray(values.purchaseOrderItems)) {
      const itemsErrors = [];

      values.purchaseOrderItems.forEach((item, index) => {
        const itemErrors = {};
        // Global validations
        if (!values.globalVendor && values.purchaseOrderItems.length > 0) {
          if (!errors.global) errors.global = {};
          errors.global.vendor = "Global vendor selection is required";
        }
        // For retail mode, check if global source is set
        if (orderMode === "retail" && values.purchaseOrderItems.length > 0 && !values.globalSource) {
          if (!errors.global) errors.global = {};
          errors.global.source = "Global source selection is required for retail orders";
        }
        // Retail-specific validations
        if (orderMode === "retail") {
          // if (!item.vendorBranchId) {
          //   itemErrors.vendorBranchId = "Source warehouse required";
          // }

          // Validate cartons not exceeding warehouse stock
          if (item.cartonsAvailable !== undefined && item.cartons && isInternalWarehouse) {
            const available = Number(item.cartonsAvailable);
            const requested = Number(item.cartons);
            if (requested > available) {
              itemErrors.cartons = `Only ${available} cartons available`;
            }
          }

          // Additional validation for cartons > 0 when cartonsAvailable is 0
          if (item.cartonsAvailable === 0 && item.cartons > 0) {
            itemErrors.cartons = "No cartons available";
          }
        }

        // Warehouse-specific validations
        if (isWarehouse) {
          if (item.minShoeSize === undefined || item.minShoeSize === "") {
            itemErrors.minShoeSize = "Min size required";
          } else {
            // Validate min size exists in system
            if (sizeData.length > 0) {
              const sizeExists = sizeData.some(size => size.name === item.minShoeSize.toString());
              if (!sizeExists) {
                itemErrors.minShoeSize = "Size does not exist in system";
              }
            }
          }

          if (item.maxShoeSize === undefined || item.maxShoeSize === "") {
            itemErrors.maxShoeSize = "Max size required";
          } else {
            // Validate max size exists in system
            if (sizeData.length > 0) {
              const sizeExists = sizeData.some(size => size.name === item.maxShoeSize.toString());
              if (!sizeExists) {
                itemErrors.maxShoeSize = "Size does not exist in system";
              }
            }

            // Validate max >= min
            if (item.minShoeSize !== undefined && Number(item.maxShoeSize) < Number(item.minShoeSize)) {
              itemErrors.maxShoeSize = "Max must be ≥ min";
            }
          }
        }

        // Retail + external source size validation
        if (orderMode === "retail" && !isWarehouse) {
          if (item.minShoeSize && sizeData.length > 0) {
            const sizeExists = sizeData.some(size => size.name === item.minShoeSize.toString());
            if (!sizeExists) {
              itemErrors.minShoeSize = "Size does not exist in system";
            }
          }

          if (item.maxShoeSize && sizeData.length > 0) {
            const sizeExists = sizeData.some(size => size.name === item.maxShoeSize.toString());
            if (!sizeExists) {
              itemErrors.maxShoeSize = "Size does not exist in system";
            }

            // Validate max >= min only if both are provided
            if (item.minShoeSize && item.maxShoeSize && Number(item.maxShoeSize) < Number(item.minShoeSize)) {
              itemErrors.maxShoeSize = "Max must be ≥ min";
            }
          }
        }

        if (Object.keys(itemErrors).length > 0) {
          itemsErrors[index] = itemErrors;
        }
      });

      if (itemsErrors.length > 0) {
        errors.purchaseOrderItems = itemsErrors;
      }
    }
    return errors;
  };

  // Handle retail product selection with prefill
  // const handleRetailProductSelect = (index, selectedInventoryId, setFieldValue) => {
  //   const inv = warehouseInventory.find((w) => String(w.id) === String(selectedInventoryId));
  //   if (!inv) return;
  //   setFieldValue(`purchaseOrderItems[${index}].productId`, inv.productId || "");
  //   setFieldValue(`purchaseOrderItems[${index}].productCode`, inv.productCode || "");
  //   setFieldValue(`purchaseOrderItems[${index}].cartonsAvailable`, inv.cartons || 0);
  //   setFieldValue(`purchaseOrderItems[${index}].quantityPerCarton`, inv.quantityPerCarton || 0);
  //   setFieldValue(`purchaseOrderItems[${index}].productAliasName`, inv.aliasProductName || 0);
  //   setFieldValue(`purchaseOrderItems[${index}].vendorBranchId`, inv.branchId);

  //   // Prefill per-pair prices for retail mode
  //   // if (orderMode === "retail") {
  //   //   if (inv.buyingPricePerCarton != null && inv.quantityPerCarton > 0) {
  //   //     const buyingPricePerPair = inv.buyingPricePerCarton / inv.quantityPerCarton;
  //   //     setFieldValue(`purchaseOrderItems[${index}].buyingPricePerPair`, buyingPricePerPair.toFixed(2));
  //   //   }
  //   // }

  //   // Set vendor
  //   const realVendorId = productCodeToVendorMap[inv.productCode];
  //   if (realVendorId) {
  //     setFieldValue(`purchaseOrderItems[${index}].vendorId`, realVendorId);
  //   }

  //   // Find and prefill from purchase orders
  //   const poItemMatch = (Array.isArray(purchaseOrdersData) ? purchaseOrdersData : [])
  //     .flatMap((po) => (po.purchaseOrderItems || []).map((item) => ({ ...item, _po: po })))
  //     .find((it) => it.productCode === inv.productCode);
  //   if (poItemMatch) {
  //      if (orderMode === "retail" && poItemMatch.aliasProductName != null ) {
  //       setFieldValue(`purchaseOrderItems[${index}].aliasProductName`, poItemMatch.aliasProductName);
  //      }
  //     if (orderMode !== 'retail' && poItemMatch.uomId) {
  //       setFieldValue(`purchaseOrderItems[${index}].uomId`, poItemMatch.uomId);
  //     }
  //   }
  // };
  // Update the handleRetailProductSelect function


  const resetItemFields = (index, setFieldValue) => {
    const fieldsToReset = [
      'warehouseInventoryId',
      'productId',
      'productCode',
      'productAliasName',
      'productName',
      'minShoeSize',
      'maxShoeSize',
      'vendorId',
      'cartons',
      'cartonsAvailable',
      'quantityPerCarton',
      'buyingPricePerPair',
      'sellingPricePerPair',
      'buyingPricePerCarton',
      'sellingPricePerCarton',
      'vendorComments',
      'isProductSelected'
    ];

    fieldsToReset.forEach(field => {
      setFieldValue(`purchaseOrderItems.${index}.${field}`, "");
    });
  };

  // Submit handler
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const itemsArray = values.purchaseOrderItems
        .map((item) => {
          // Use global values for all items
          const vendorId = values.globalVendor;
          const vendorBranchId = values.globalSource;
          const vendorComments = values.globalVendorComments;

          // Determine if source is external warehouse
          const selectedSourceBranch = branchData.find(b => String(b.id) === String(vendorBranchId));
          const isExternalWarehouse = orderMode === "warehouse"
            ? 0
            : (() => {
              return selectedSourceBranch ? Number(selectedSourceBranch.isWarehouse) === 0 : true;
            })();
          const now = new Date();
          const pad = (n) => String(n).padStart(2, "0");
          const currentTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
          const todayDate = getTodayLocalDate();

          // If item.createdDate is missing, use today
          const safeCreatedDate = item.createdDate && item.createdDate.trim() !== ""
            ? item.createdDate
            : todayDate;

          const safeStockDate = item.stockDueDate && item.stockDueDate.trim() !== ""
            ? item.stockDueDate
            : todayDate;

          // Keep local datetime without explicit timezone offset.
          // SQL datetime persistence + explicit +03:00 payloads were ending up
          // stored 3 hours behind in PO/PO-item timestamps.
          const combinedDateTime = `${safeCreatedDate}T${currentTime}`;
          const combinedStockDateTime = `${safeStockDate}T${currentTime}`;

          // ✔️ Compute isBackDated
          const isBackDated = safeCreatedDate === todayDate ? 0 : 1;

          const parsePrice = (price) => {
            const num = Number(price);
            return isNaN(num) ? 0 : Math.round(num);
          };

          const fields = [
            `vendorId: ${vendorId}`,
            `productId: ${item.productId}`,
            `uomId: ${item.uomId}`,
            `cartons: ${item.cartons}`,
            `quantityPerCarton: ${item.quantityPerCarton}`,
            `aliasProductName: "${item.productAliasName || ''}"`,
            `vendorComments: "${vendorComments || ''}"`,
            `isExternalWarehouse: ${isExternalWarehouse ? 1 : 0}`,
            ...(orderMode === "warehouse" ? [
              `buyingPricePerCarton: ${parsePrice(item.buyingPricePerCarton)}`,
              `sellingPricePerCarton: ${parsePrice(item.sellingPricePerCarton)}`,
            ] : [
              `buyingPricePairs: ${parsePrice(item.buyingPricePerPair)}`,
              `sellingPricePairs: ${parsePrice(item.sellingPricePerPair)}`,
            ]),
            `productCode: "${item.productCode}"`,
            `stockDueDate: "${combinedStockDateTime}"`,
            `createdDate: "${combinedDateTime}"`,
            `reorderPoint: ${item.reorderPoint}`,
            `isActive: true`,
            `branchId: ${values.branchId}`,
            `isBackDated: ${isBackDated}`,

          ];


          if (item.minShoeSize !== "") fields.push(`minShoeSize: ${item.minShoeSize}`);
          if (item.maxShoeSize !== "") fields.push(`maxShoeSize: ${item.maxShoeSize}`);
          if (item.colorId) fields.push(`colorId: ${item.colorId}`);

          return `{ ${fields.join(", ")} }`;
        })
        .join(", ");

      const mutation = `
        mutation {
          createPurchaseOrder(purchaseOrderItems: [${itemsArray}]) {
            id
            vendorId
            productCode
            totalAmount
            orderDate
          }
        }
      `;

      const response = await graphqlQuery(mutation, createOrder_base_url);
      if (response && (response.id || response.createPurchaseOrder)) {
        // Update warehouse inventory for retail orders
        if (orderMode === "retail") {
          for (const item of values.purchaseOrderItems) {
            const cartonsOrdered = Number(item.cartons);
            if (!item.productCode || !cartonsOrdered || cartonsOrdered <= 0) continue;

            const updateMutation = `
              mutation {
                updateWarehouseInventory(
                  productCode: "${item.productCode}", 
                  branchId: ${item.vendorBranchId}, 
                  cartonsDeducted: ${cartonsOrdered}
                ) {
                  id
                  productCode
                  cartons
                }
              }
            `;
            try {
              await graphqlQuery(updateMutation, createOrder_base_url);
            } catch (err) {
              console.error("Warehouse update failed:", item.productCode, err);
            }
          }
        }

        props.onClose();
        await Swal.fire(
          "Success!",
          `${values.purchaseOrderItems.length} item(s) ordered successfully!`,
          "success"
        );
        if (props.onServerAction()) {
          props.refetchData(); // This will trigger loadPurchaseOrders in the parent
        }

        resetForm();
      } else {
        throw new Error("Invalid response from server.");
      }
    } catch (error) {
      console.error("Error creating purchase order:", error);
      Swal.fire("Error", error.message || "Failed to create order.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
        <CircularProgress size={48} />
      </Box>
    );
  }

 
  // Add this function to handle price calculations
  const calculateCartonPrice = (pairPrice, quantityPerCarton) => {
    if (!pairPrice || !quantityPerCarton) return '';
    const calculated = parseFloat(pairPrice) * parseInt(quantityPerCarton);
    return Math.round(calculated).toString(); // Return as integer string
  };
  // const productOptionsForBranch = (branchId, selectedProductId = null) => {
  //   if (!branchId) return [];

  //   const selectedBranch = branchData.find(b => String(b.id) === String(branchId));
  //   const isWarehouseSource = selectedBranch ? Number(selectedBranch.isWarehouse) === 1 : true;
  //   setIsInternalWarehouse(isWarehouseSource);

  //   // Use different data source based on source type
  //   let items = isWarehouseSource 
  //     ? warehouseInventory.filter((w) => w.branchId)
  //     : allInventory.filter((inv) => inv.branchId); // Use allInventory for external sources

  //   // Filter by selected product if provided
  //   if (selectedProductId) {
  //     items = items.filter(item => String(item.productId) === String(selectedProductId));
  //   }

  //   return items.map((it) => {
  //     const product = productData.find((p) => String(p.id) === String(it.productId));
  //     const branch = branchData.find((b) => String(b.id) === String(it.branchId));

  //     if (!isWarehouseSource) {
  //       return {
  //         value: it.id,
  //         label: `${product?.productName || "Unknown"} - ${it.productCode}`,
  //         productCode: it.productCode,
  //         productId: it.productId,
  //         productAliasName: it.productAliasName,
  //         cartonsAvailable: undefined,
  //         buyingPricePerCarton: it.buyingPricePerCarton,
  //         quantityPerCarton: it.quantityPerCarton,
  //         branchId: it.branchId,
  //         minShoeSize: it.minShoeSize,
  //         maxShoeSize: it.maxShoeSize,
  //         productName: product?.productName || "",
  //       };
  //     }

  //     return {
  //       value: it.id,
  //       label: `${it.productCode} — ${product?.productName || "Unknown"} (${it.cartons || 0} cartons)`,
  //       productCode: it.productCode,
  //       productId: it.productId,
  //       productAliasName: it.productAliasName,
  //       cartonsAvailable: it.cartons || 0,
  //       buyingPricePerCarton: it.buyingPricePerCarton,
  //       quantityPerCarton: it.quantityPerCarton,
  //       branchId: it.branchId,
  //       minShoeSize: it.minShoeSize,
  //       maxShoeSize: it.maxShoeSize,
  //     };
  //   });
  // };
  const productOptionsForBranch = (branchId, selectedProductId = null) => {
    if (!branchId) return [];

    const selectedBranch = branchData.find(b => String(b.id) === String(branchId));
    const isWarehouseSource = selectedBranch ? Number(selectedBranch.isWarehouse) === 1 : true;
    setIsInternalWarehouse(isWarehouseSource);

    // Use different data source based on source type
    let items = isWarehouseSource
      ? warehouseInventory.filter((w) => w.branchId)
      : allInventory.filter((inv) => inv.branchId);

    // Filter by selected product if provided
    if (selectedProductId) {
      items = items.filter(item => String(item.productId) === String(selectedProductId));
    }

    // Filter by branch for warehouse sources, show all for external
    if (isWarehouseSource) {
      items = items.filter((w) => String(w.branchId) === String(branchId));
    }

    // Create a Set to track unique product codes
    const uniqueProductCodes = new Set();
    const uniqueItems = [];

    items.forEach((it) => {
      if (!uniqueProductCodes.has(it.productCode)) {
        uniqueProductCodes.add(it.productCode);
        uniqueItems.push(it);
      }
    });

    return uniqueItems.map((it) => {
      const product = productData.find((p) => String(p.id) === String(it.productId));
      const branch = branchData.find((b) => String(b.id) === String(it.branchId));

      if (!isWarehouseSource) {
        // External source - from AllInventoryView
        return {
          value: it.id,
          label: `${product?.productName || it.productName || "Unknown"} - ${it.productCode}`,
          productCode: it.productCode,
          productId: it.productId,
          productAliasName: it.aliasProductName || "",
          cartonsAvailable: undefined, // No cartons available for external sources
          buyingPricePerCarton: undefined, // Not available for external sources
          quantityPerCarton: it.quantityPerCarton || 0,
          branchId: it.branchId,
          minShoeSize: it.minShoeSize,
          maxShoeSize: it.maxShoeSize,
          productName: product?.productName || it.productName || "",
          // These are the fields from AllInventoryView
          buyingPricePerPair: it.buyingPrice,
          sellingPricePerPair: it.sellingPrice,
          reorderPoint: it.reorderPoint,
        };
      }

      // Warehouse source - from AllWarehouseInventory
      return {
        value: it.id,
        label: `${it.productCode} — ${product?.productName || "Unknown"} (${it.cartons || 0} cartons)`,
        productCode: it.productCode,
        productId: it.productId,
        productAliasName: it.aliasProductName || "",
        cartonsAvailable: it.cartons || 0,
        buyingPricePerCarton: it.buyingPricePerCarton,
        quantityPerCarton: it.quantityPerCarton,
        branchId: it.branchId,
        minShoeSize: it.minShoeSize,
        maxShoeSize: it.maxShoeSize,
        // For warehouse, we need to calculate per-pair prices
        buyingPricePerPair: it.buyingPricePerCarton && it.quantityPerCarton
          ? (it.buyingPricePerCarton / it.quantityPerCarton).toFixed(2)
          : undefined,
        sellingPricePerPair: undefined, // Not available in warehouse inventory
        reorderPoint: it.reorderPoint,
      };
    });
  };
  // Create a separate function to get unique product names for external sources
  const getUniqueProductNames = () => {
    const uniqueProducts = [];
    const seenNames = new Set();

    productData.forEach((product) => {
      if (product.productName && !seenNames.has(product.productName)) {
        seenNames.add(product.productName);
        uniqueProducts.push({
          value: product.id,
          label: product.productName,
          productCode: product.productCode,
        });
      }
    });

    return uniqueProducts;
  };

  const getIn = (obj, path) => {
    const keys = path.split(/[\.\[\]]+/).filter(Boolean);
    return keys.reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
  };

  const today = new Date();
const localDate = today.getFullYear() + "-" +
  String(today.getMonth() + 1).padStart(2, "0") + "-" +
  String(today.getDate()).padStart(2, "0");

  

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: "1400px", margin: "0 auto" }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="600" gutterBottom>
          Create Purchase Order
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {orderMode === "warehouse"
            ? "Order new stock from suppliers for warehouse storage"
            : "Transfer stock from warehouse or order new stock from suppliers for the retail branch"}
        </Typography>
      </Box>

      {/* Order Type Toggle */}
      {!isBranchUser && (
      <Paper elevation={0} sx={{ p: 2, mb: 3, backgroundColor: "grey.50", borderRadius: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
          <Typography variant="body1" fontWeight="500">
            Order Type:
          </Typography>
          <ToggleButtonGroup
            color="primary"
            value={orderMode}
            exclusive
            onChange={(event, value) => {
              if (!value) return;
              setOrderMode(value);
             if (formikRef.current) {
                // Only reset branchId if no token branch is locked
                if (!tokenBranchId) {
                  formikRef.current.setFieldValue("branchId", "");
                }
                formikRef.current.setFieldValue("purchaseOrderItems", []);
              }
            }}
          >
            <ToggleButton value="warehouse">Warehouse Order</ToggleButton>
            <ToggleButton value="retail">Retail Order</ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Paper>
      )}
      {/* For branch users: show a locked indicator */}
    {isBranchUser && (
      <Paper elevation={0} sx={{ p: 2, mb: 3, backgroundColor: "grey.50", borderRadius: 2 }}>
        <Typography variant="body1" fontWeight="500">
          Order Type: Retail (locked for your branch)
        </Typography>
      </Paper>
    )}
      {/* Form */}
      <Formik
        innerRef={formikRef}
        initialValues={{
          branchId: tokenBranchId || "",
          purchaseOrderItems: [],
          // Add these global fields:
          globalSource: "",
          globalVendor: "",
          globalVendorComments: "",
        }}
        validationSchema={getValidationSchema(orderMode)}
        validate={validateFormConditional}
        onSubmit={handleSubmit}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
          errors,
          touched,
        }) => {
          const handleRetailProductSelect = (index, selectedInventoryId, setFieldValue, isFromProductNameDropdown = false) => {
            if (isFromProductNameDropdown) {
              // Handle selection from product name dropdown
              const selectedProduct = productData.find(p => String(p.id) === String(selectedInventoryId));
              if (!selectedProduct) return;

              // Clear existing values first
              setFieldValue(`purchaseOrderItems.${index}.warehouseInventoryId`, "");
              setFieldValue(`purchaseOrderItems.${index}.cartonsAvailable`, undefined);

              // Set new values and enable fields
              setFieldValue(`purchaseOrderItems.${index}.productId`, selectedProduct.id || "");
              setFieldValue(`purchaseOrderItems.${index}.productCode`, selectedProduct.productCode || "");
              setFieldValue(`purchaseOrderItems.${index}.productName`, selectedProduct.productName || "");
              setFieldValue(`purchaseOrderItems.${index}.productAliasName`, "");
              setFieldValue(`purchaseOrderItems.${index}.isProductSelected`, false);

              // DO NOT prefill vendor in any scenario
              setFieldValue(`purchaseOrderItems.${index}.vendorId`, "");

              // Try to find this product in inventory to prefill more data
              const inventoryItem = allInventory.find(inv => inv.productCode === selectedProduct.productCode) ||
                warehouseInventory.find(inv => inv.productCode === selectedProduct.productCode);


              // Prefill sizes from product data
              if (selectedProduct.minShoeSize !== undefined && selectedProduct.minShoeSize !== null) {
                setFieldValue(`purchaseOrderItems.${index}.minShoeSize`, selectedProduct.minShoeSize);
              }
              if (selectedProduct.maxShoeSize !== undefined && selectedProduct.maxShoeSize !== null) {
                setFieldValue(`purchaseOrderItems.${index}.maxShoeSize`, selectedProduct.maxShoeSize);
              }

              // Prefill reorder point from product data
              if (selectedProduct.reorderPoint !== undefined && selectedProduct.reorderPoint !== null) {
                setFieldValue(`purchaseOrderItems.${index}.reorderPoint`, selectedProduct.reorderPoint);
              }

              // Prefill prices - FIRST try from product data, then from inventory
              if (selectedProduct.buyingPrice !== undefined && selectedProduct.buyingPrice !== null) {
                setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, selectedProduct.buyingPrice);
              } else if (selectedProduct.averageBuyingPrice !== undefined && selectedProduct.averageBuyingPrice !== null) {
                // Try averageBuyingPrice as fallback
                setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, selectedProduct.averageBuyingPrice);
              } else if (inventoryItem?.buyingPrice !== undefined && inventoryItem?.buyingPrice !== null) {
                // Try from inventory
                setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, inventoryItem.buyingPrice);
              }

              if (selectedProduct.sellingPrice !== undefined && selectedProduct.sellingPrice !== null) {
                setFieldValue(`purchaseOrderItems.${index}.sellingPricePerPair`, selectedProduct.sellingPrice);
              } else if (selectedProduct.averageSellingPrice !== undefined && selectedProduct.averageSellingPrice !== null) {
                // Try averageSellingPrice as fallback
                setFieldValue(`purchaseOrderItems.${index}.sellingPricePerPair`, selectedProduct.averageSellingPrice);
              } else if (inventoryItem?.sellingPrice !== undefined && inventoryItem?.sellingPrice !== null) {
                // Try from inventory
                setFieldValue(`purchaseOrderItems.${index}.sellingPricePerPair`, inventoryItem.sellingPrice);
              }

              // Also try to get quantity per carton
              if (inventoryItem?.quantityPerCarton) {
                setFieldValue(`purchaseOrderItems.${index}.quantityPerCarton`, inventoryItem.quantityPerCarton);
              }

              // Look for historical data from purchase orders
              const poItemMatch = (Array.isArray(purchaseOrdersData) ? purchaseOrdersData : [])
                .flatMap((po) => (po.purchaseOrderItems || []).map((item) => ({ ...item, _po: po })))
                .find((it) => it.productCode === selectedProduct.productCode);

              if (poItemMatch) {

                // Get current item value from Formik values
                const currentItem = values.purchaseOrderItems[index];

                // Prefill prices from purchase order if not already set
                if (!currentItem?.buyingPricePerPair && poItemMatch.buyingPricePerPair) {
                  setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, poItemMatch.buyingPricePerPair);
                } else if (!currentItem?.buyingPricePerPair && poItemMatch.buyingPricePairs) {
                  setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, poItemMatch.buyingPricePairs);
                }

                if (!currentItem?.sellingPricePerPair && poItemMatch.sellingPricePerPair) {
                  setFieldValue(`purchaseOrderItems.${index}.sellingPricePerPair`, poItemMatch.sellingPricePerPair);
                } else if (!currentItem?.sellingPricePerPair && poItemMatch.sellingPricePairs) {
                  setFieldValue(`purchaseOrderItems.${index}.sellingPricePerPair`, poItemMatch.sellingPricePairs);
                }

                // Prefill quantity per carton from purchase order
                if (!currentItem?.quantityPerCarton && poItemMatch.quantityPerCarton) {
                  setFieldValue(`purchaseOrderItems.${index}.quantityPerCarton`, poItemMatch.quantityPerCarton);
                }

                // Prefill UOM from purchase order
                if (!currentItem?.uomId && poItemMatch.uomId) {
                  setFieldValue(`purchaseOrderItems.${index}.uomId`, poItemMatch.uomId);
                }
              }


              return;
            }

            // ... rest of the function remains the same
            // Find item in either warehouseInventory or allInventory based on source type
            const selectedSourceBranch = branchData.find(b => String(b.id) === String(values.globalSource));
            const isSourceWarehouse = selectedSourceBranch ? Number(selectedSourceBranch.isWarehouse) === 1 : false;

            const dataSource = isSourceWarehouse ? warehouseInventory : allInventory;

            // Original logic for warehouse inventory selection
            const inv = dataSource.find((w) => String(w.id) === String(selectedInventoryId));
            if (!inv) return;

            // Set product information and disable fields
            setFieldValue(`purchaseOrderItems.${index}.productId`, inv.productId || "");
            setFieldValue(`purchaseOrderItems.${index}.productCode`, inv.productCode || "");
            setFieldValue(`purchaseOrderItems.${index}.isProductSelected`, true);

            // Prefill sizes
            if (inv.minShoeSize !== undefined && inv.minShoeSize !== null) {
              setFieldValue(`purchaseOrderItems.${index}.minShoeSize`, inv.minShoeSize);
            }
            if (inv.maxShoeSize !== undefined && inv.maxShoeSize !== null) {
              setFieldValue(`purchaseOrderItems.${index}.maxShoeSize`, inv.maxShoeSize);
            }

            // Prefill prices based on source type
            if (isSourceWarehouse) {
              // For warehouse source - calculate per-pair price from per-carton price
              if (inv.buyingPricePerCarton && inv.quantityPerCarton && inv.quantityPerCarton > 0) {
                const buyingPricePerPair = inv.buyingPricePerCarton / inv.quantityPerCarton;
                setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, buyingPricePerPair.toFixed(2));
              }
            } else {
              // For external source - use direct per-pair prices
              if (inv.buyingPrice !== undefined && inv.buyingPrice !== null) {
                setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, inv.buyingPrice);
              }

              if (inv.sellingPrice !== undefined && inv.sellingPrice !== null) {
                setFieldValue(`purchaseOrderItems.${index}.sellingPricePerPair`, inv.sellingPrice);
              }
            }

            // Prefill reorder point
            if (inv.reorderPoint !== undefined && inv.reorderPoint !== null) {
              setFieldValue(`purchaseOrderItems.${index}.reorderPoint`, inv.reorderPoint);
            }

            // Only set cartonsAvailable if source is a warehouse
            if (isSourceWarehouse) {
              setFieldValue(`purchaseOrderItems.${index}.cartonsAvailable`, inv.cartons || 0);
            } else {
              setFieldValue(`purchaseOrderItems.${index}.cartonsAvailable`, undefined);
            }

            setFieldValue(`purchaseOrderItems.${index}.quantityPerCarton`, inv.quantityPerCarton || 0);

            // Set product alias name based on source
            if (isSourceWarehouse) {
              setFieldValue(`purchaseOrderItems.${index}.productAliasName`, inv.aliasProductName || "");
            } else {
              setFieldValue(`purchaseOrderItems.${index}.productAliasName`, inv.aliasProductName || inv.productAliasName || "");
            }

            // Set product name from product data
            const product = productData.find(p => String(p.id) === String(inv.productId));
            setFieldValue(`purchaseOrderItems.${index}.productName`, product?.productName || inv.productName || "");

            // Find and prefill from purchase orders for additional data
            const poItemMatch = (Array.isArray(purchaseOrdersData) ? purchaseOrdersData : [])
              .flatMap((po) => (po.purchaseOrderItems || []).map((item) => ({ ...item, _po: po })))
              .find((it) => it.productCode === inv.productCode);

            if (poItemMatch) {
              if (orderMode === "retail" && poItemMatch.aliasProductName != null) {
                setFieldValue(`purchaseOrderItems.${index}.aliasProductName`, poItemMatch.aliasProductName);
              }
              if (orderMode !== 'retail' && poItemMatch.uomId) {
                setFieldValue(`purchaseOrderItems.${index}.uomId`, poItemMatch.uomId);
              }
            }


            // NEW: Prefill from latest retail purchase order item
            if (orderMode === "retail") {
              ;

              // Filter to find matching items (REMOVED isExternalWarehouse filter)
              const matchingItems = purchaseOrderItemsData.filter((item) => item.productCode === inv.productCode);

              if (matchingItems.length > 0) {
              }

              // Sort by date to get the latest
              const latestPOItem = matchingItems
                .sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate))[0];

              if (latestPOItem) {

                // Prefill size range
                if (latestPOItem.minShoeSize !== undefined && latestPOItem.minShoeSize !== null) {
                  setFieldValue(`purchaseOrderItems.${index}.minShoeSize`, latestPOItem.minShoeSize);
                }
                if (latestPOItem.maxShoeSize !== undefined && latestPOItem.maxShoeSize !== null) {
                  setFieldValue(`purchaseOrderItems.${index}.maxShoeSize`, latestPOItem.maxShoeSize);
                }

                // Prefill prices (retail mode uses per-pair prices)
                if (latestPOItem.buyingPricePairs !== undefined && latestPOItem.buyingPricePairs !== null) {
                  setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, latestPOItem.buyingPricePairs);
                }
                if (latestPOItem.sellingPricePairs !== undefined && latestPOItem.sellingPricePairs !== null) {
                  setFieldValue(`purchaseOrderItems.${index}.sellingPricePerPair`, latestPOItem.sellingPricePairs);
                }

                // Prefill reorder point
                if (latestPOItem.reorderPoint !== undefined && latestPOItem.reorderPoint !== null) {
                  setFieldValue(`purchaseOrderItems.${index}.reorderPoint`, latestPOItem.reorderPoint);
                }
              } else {
              }
            }


          };
          // const availableBranchOptions = branchOptions.filter((b) =>
          //   orderMode === "warehouse" ? b.isWarehouse : !b.isWarehouse
          // ); 
          const warehouseBranchesFromInventory = branchOptions
            .filter(branch => branch.value !== values.branchId) // Exclude the selected destination branch
            .map(branch => ({
              value: branch.value,
              label: branch.label,
              isWarehouse: branch.isWarehouse
            }));
          const availableBranchOptions = branchOptions.filter((b) => {
            if (orderMode === "warehouse") {
              // ✅ For warehouse orders — only show warehouse branches
              return b.isWarehouse;
            } else {
              // ✅ For retail orders — show only non-warehouse branches
              // and exclude those containing "external" or "outsource"
              const name = b.label.toLowerCase();
              return (
                !b.isWarehouse &&
                !name.includes("external") &&
                !name.includes("outsource")
              );
            }
          });

          const selectedBranch = branchData.find((b) => b.id === values.branchId);
          const isWarehouse = selectedBranch
            ? Number(selectedBranch.isWarehouse) === 1
            : orderMode === "warehouse";

          return (
            <form onSubmit={handleSubmit}>
              {/* Branch Selection */}
              <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
                <Autocomplete
                  options={availableBranchOptions}
                  getOptionLabel={(option) => option.label}
                  value={availableBranchOptions.find((o) => o.value === values.branchId) || null}
                  disabled={!!tokenBranchId}
                  onChange={(_, newValue) => {
                    setFieldValue("branchId", newValue?.value || "");
                    setFieldTouched("branchId", true);
                    setFieldValue("purchaseOrderItems", []);
                  }}
                  onBlur={() => setFieldTouched("branchId", true)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={orderMode === "warehouse" ? "Destination Warehouse *" : "Destination Retail Branch *"}
                      variant="outlined"
                      error={touched.branchId && Boolean(errors.branchId)}
                      helperText={(touched.branchId && errors.branchId) || (tokenBranchId ? "Destination branch is locked from your profile" : "")}
                    />
                  )}
                />
              </Paper>
              {/* Global Selections Section - MOVED HERE */}
              {values.purchaseOrderItems.length > 0 && (orderMode === "retail" || orderMode === "warehouse") && (
                <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
                  <Typography variant="h6" gutterBottom color="primary">
                    Global Settings
                  </Typography>
                  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: 2 }}>
                    {/* Global Source (for retail mode only) */}
                    {orderMode === "retail" && (
                      <Autocomplete
                        options={warehouseBranchesFromInventory}
                        getOptionLabel={(o) => o.label}
                        value={warehouseBranchesFromInventory.find((o) => o.value === values.globalSource) || null}
                        onChange={(_, newValue) => {
                          setFieldValue("globalSource", newValue?.value || "");
                          setGlobalSource(newValue?.value || "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Source *"
                            error={Boolean(touched.globalSource && errors.global?.source)}
                            helperText={touched.globalSource && errors.global?.source}
                          />
                        )}
                      />
                    )}

                    {/* Global Vendor */}
                    <Autocomplete
                      options={vendorOptions.filter(v => {
                        if (orderMode === "warehouse") {
                          return v.isInternal === 0;
                        } else {
                          // For retail mode, filter vendors based on selected source
                          const selectedSourceBranch = branchData.find(b => String(b.id) === String(values.globalSource));
                          const isSourceWarehouse = selectedSourceBranch ? Number(selectedSourceBranch.isWarehouse) === 1 : false;

                          if (isSourceWarehouse) {
                            return v.isInternal === 1;
                          } else {
                            return v.isInternal === 0;
                          }
                        }
                      })}
                      getOptionLabel={(o) => o.label}
                      value={vendorOptions.find((o) => String(o.value) === String(values.globalVendor)) || null}
                      onChange={(_, newValue) => {
                        setFieldValue("globalVendor", newValue?.value || "");
                        setGlobalVendor(newValue?.value || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Vendor *"
                          error={Boolean(touched.globalVendor && errors.global?.vendor)}
                          helperText={touched.globalVendor && errors.global?.vendor}
                        />
                      )}
                    />

                    {/* Global Vendor Comments */}
                    <TextField
                      label="Vendor Comments for All Items"
                      name="globalVendorComments"
                      value={values.globalVendorComments}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Comments that will apply to all items"
                      multiline
                      rows={2}
                    />
                  </Box>
                </Paper>
              )}

              {/* Items */}
              <FieldArray
                name="purchaseOrderItems"
                render={(arrayHelpers) => (
                  <Box>
                    {values.purchaseOrderItems.map((item, index) => {
                      const itemErrors = getIn(errors, `purchaseOrderItems.${index}`) || {};
                      const itemTouched = getIn(touched, `purchaseOrderItems.${index}`) || {};
                      // Use global source for retail mode, otherwise use item's vendorBranchId
                      const sourceBranchId = orderMode === "retail" ? values.globalSource : item.vendorBranchId;
                      const prodOptions = productOptionsForBranch(item.vendorBranchId);
                      const selectedSourceBranch = branchData.find(b => String(b.id) === String(item.vendorBranchId));
                      const isSourceWarehouse = selectedSourceBranch ? Number(selectedSourceBranch.isWarehouse) === 1 : false;

                      // Determine if this is the first item
                      const isFirstItem = index === 0;

                      return (
                        <Paper key={index} elevation={2} sx={{ p: 3, mb: 3, border: "1px solid", borderColor: "divider" }}>
                          {/* Item Header */}
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                            <Typography variant="h6" fontWeight="600">
                              Item {index + 1}

                            </Typography>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              onClick={() => {
                                arrayHelpers.remove(index);
                                // If removing the first item and there are other items, reset locks

                              }}
                            >
                              Remove
                            </Button>
                          </Box>


                          {/* Product Selection */}
                          <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle2" color="primary" fontWeight="600" gutterBottom>
                              Product Information
                            </Typography>
                            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" }, gap: 2 }}>

                              {orderMode === "retail" ? (
                                <>
                                  {/* <Autocomplete
                                  options={warehouseBranchesFromInventory}
                                  getOptionLabel={(o) => o.label}
                                  value={warehouseBranchesFromInventory.find((o) => o.value === item.vendorBranchId) || null}
                                  onChange={(_, newValue) => {
                                    const sourceValue = newValue?.value || "";
                                   
                                  }}
                                  onBlur={() => setFieldTouched(`purchaseOrderItems.${index}.vendorBranchId`, true)}
                                  disabled={!isFirstItem}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Source *"
                                      error={Boolean(itemTouched.vendorBranchId && itemErrors.vendorBranchId)}
                                      helperText={
                                        itemTouched.vendorBranchId && itemErrors.vendorBranchId ||
                                        (!isFirstItem ? "Locked to first item's selection" : "")
                                      }
                                      InputProps={{
                                        ...params.InputProps,
                                        readOnly: !isFirstItem ,
                                      }}
                                    />
                                  )}
                                />
                                       */}

                                  {/* <Autocomplete
                                    options={prodOptions}
                                    getOptionLabel={(o) => o.label}
                                    value={
                                      prodOptions.find((o) => o.value === item.warehouseInventoryId) || null
                                    }
                                    disabled={!item.vendorBranchId}
                                    onChange={(_, newValue) => {
                                      setFieldValue(
                                        `purchaseOrderItems.${index}.warehouseInventoryId`,
                                        newValue?.value || ""
                                      );
                                      setFieldTouched(`purchaseOrderItems.${index}.productId`, true);
                                      if (newValue) {
                                        handleRetailProductSelect(index, newValue.value, setFieldValue);
                                      }
                                    }}
                                    onBlur={() => setFieldTouched(`purchaseOrderItems.${index}.productId`, true)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Select Product *"
                                        error={Boolean(itemTouched.productId && itemErrors.productId)}
                                        helperText={
                                          (itemTouched.productId && itemErrors.productId) ||
                                          (item.cartonsAvailable
                                            ? `Available: ${item.cartonsAvailable} cartons`
                                            : "")
                                        }
                                      />
                                    )}
                                  /> */}
                                  {!isSourceWarehouse && (

                                    <Autocomplete
                                      options={getUniqueProductNames()}
                                      getOptionLabel={(option) => option.label}
                                      value={getUniqueProductNames().find((o) => o.value === item.productId) || null}
                                      onChange={(_, newValue) => {
                                        if (newValue) {
                                          setFieldValue(`purchaseOrderItems.${index}.productId`, newValue.value || "");
                                          setFieldValue(`purchaseOrderItems.${index}.productCode`, newValue.productCode || "");
                                          setFieldValue(`purchaseOrderItems.${index}.productName`, newValue.label || "");
                                          setFieldTouched(`purchaseOrderItems.${index}.productName`, true);
                                          handleRetailProductSelect(index, newValue.value, setFieldValue, true);
                                        } else {
                                          setFieldValue(`purchaseOrderItems.${index}.productId`, "");
                                          setFieldValue(`purchaseOrderItems.${index}.productCode`, "");
                                          setFieldValue(`purchaseOrderItems.${index}.productName`, "");
                                          setFieldValue(`purchaseOrderItems.${index}.warehouseInventoryId`, "");
                                        }
                                      }}
                                      onBlur={() => setFieldTouched(`purchaseOrderItems.${index}.productName`, true)}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Product Name"
                                          error={Boolean(itemTouched.productName && itemErrors.productName)}
                                          helperText={itemTouched.productName && itemErrors.productName || "Select product name to filter products"}
                                        />
                                      )}
                                      isOptionEqualToValue={(option, value) => option.value === value.value}
                                      filterOptions={(options, { inputValue }) => {
                                        return options.filter(option =>
                                          option.label.toLowerCase().includes(inputValue.toLowerCase())
                                        );
                                      }}
                                    />
                                  )}


                                  <Autocomplete
                                    options={productOptionsForBranch(values.globalSource, item.productId)}
                                    getOptionLabel={(o) => o.label}
                                    value={productOptionsForBranch(values.globalSource, item.productId).find((o) => o.value === item.warehouseInventoryId) || null}
                                    disabled={!values.globalSource}
                                    onChange={(_, newValue) => {
                                      setFieldValue(
                                        `purchaseOrderItems.${index}.warehouseInventoryId`,
                                        newValue?.value || ""
                                      );
                                      setFieldTouched(`purchaseOrderItems.${index}.productId`, true);

                                      if (newValue) {
                                        handleRetailProductSelect(index, newValue.value, setFieldValue, false);
                                      } else {
                                        // When clearing the selection, enable the fields
                                        setFieldValue(`purchaseOrderItems.${index}.isProductSelected`, false);
                                        setFieldValue(`purchaseOrderItems.${index}.productCode`, "");
                                        setFieldValue(`purchaseOrderItems.${index}.productAliasName`, "");
                                      }
                                    }}
                                    onBlur={() => setFieldTouched(`purchaseOrderItems.${index}.productId`, true)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Select Product *"
                                        error={Boolean(itemTouched.productId && itemErrors.productId)}
                                        helperText={
                                          (itemTouched.productId && itemErrors.productId) ||
                                          (item.cartonsAvailable !== undefined && isSourceWarehouse
                                            ? `Available: ${item.cartonsAvailable} cartons`
                                            : isSourceWarehouse === false
                                              ? "External source - no stock limit"
                                              : !values.globalSource
                                                ? "Select a source first"
                                                : "")
                                        }
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    renderOption={(props, option) => {
                                      const optionSourceBranch = branchData.find(b => String(b.id) === String(option.branchId));
                                      const isOptionWarehouse = optionSourceBranch ? Number(optionSourceBranch.isWarehouse) === 1 : false;

                                      return (
                                        <Box component="li" {...props} sx={{ display: 'block', padding: '8px 16px' }}>
                                          <Typography variant="body1" fontWeight={500}>
                                            {isOptionWarehouse ? option.label : option.productName || option.label}
                                          </Typography>
                                          <Typography variant="body2" color="text.secondary">
                                            {isOptionWarehouse ? `Product Code: ${option.productCode}` : `Code: ${option.productCode}`}
                                          </Typography>
                                          {/* Only show carton availability and badge for warehouse sources */}
                                          {isOptionWarehouse && option.cartonsAvailable !== undefined && (
                                            <>
                                              <Chip
                                                size="small"
                                                label={`${option.cartonsAvailable} cartons available`}
                                                color={option.cartonsAvailable > 0 ? "success" : "error"}
                                                sx={{ mt: 0.5, height: 20, fontSize: '0.7rem' }}
                                              />
                                              <Chip
                                                size="small"
                                                label="Warehouse"
                                                color="primary"
                                                variant="outlined"
                                                sx={{ mt: 0.5, ml: 0.5, height: 20, fontSize: '0.7rem' }}
                                              />
                                            </>
                                          )}
                                        </Box>
                                      );
                                    }}
                                    filterOptions={(options, { inputValue }) => {
                                      const filtered = options.filter(option =>
                                        option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                                        option.productCode.toLowerCase().includes(inputValue.toLowerCase()) ||
                                        (option.productName && option.productName.toLowerCase().includes(inputValue.toLowerCase()))
                                      );
                                      return inputValue ? filtered : filtered.slice(0, 6);
                                    }}
                                    ListboxProps={{
                                      style: {
                                        maxHeight: 300,
                                      }
                                    }}
                                  />
                                  {/* Make Product Code and Alias editable only when source is NOT a warehouse */}
                                  {!isSourceWarehouse && (
                                    <>
                                      <TextField
                                        label="Product Code *"
                                        name={`purchaseOrderItems.${index}.productCode`}
                                        value={item.productCode || ""}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(itemTouched.productCode && itemErrors.productCode)}
                                        helperText={itemTouched.productCode && itemErrors.productCode}
                                        disabled={item.isProductSelected} // Disable if product was selected from dropdown
                                        InputProps={{
                                          readOnly: item.isProductSelected, // Make read-only if product was selected
                                        }}
                                      />
                                      <TextField
                                        label="Product Alias"
                                        name={`purchaseOrderItems.${index}.productAliasName`}
                                        value={item.productAliasName || ""}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={Boolean(itemTouched.productAliasName && itemErrors.productAliasName)}
                                        helperText={itemTouched.productAliasName && itemErrors.productAliasName || "Product Alias"}
                                        placeholder="e.g., Summer Collection Sneakers"
                                        disabled={item.isProductSelected} // Disable if product was selected from dropdown
                                        InputProps={{
                                          readOnly: item.isProductSelected, // Make read-only if product was selected
                                        }}
                                      />
                                    </>
                                  )}

                                  {/* Show Product Code and Alias as read-only when source IS a warehouse */}
                                  {isSourceWarehouse && (
                                    <>
                                      <TextField
                                        label="Product Code"
                                        value={item.productCode || ""}
                                        disabled
                                        InputProps={{ readOnly: true }}
                                      />
                                      <TextField
                                        label="Product Alias"
                                        value={item.productAliasName || ""}
                                        disabled
                                        InputProps={{ readOnly: true }}
                                        helperText="Product Alias"
                                      />
                                    </>
                                  )}

                                </>
                              ) : (
                                <>
                                  <Autocomplete
                                    options={productOptions}
                                    getOptionLabel={(o) => o.label}
                                    value={productOptions.find((o) => o.value === item.productId) || null}
                                    onChange={(_, newValue) => {
                                      setFieldValue(`purchaseOrderItems.${index}.productId`, newValue?.value || "");
                                      setFieldTouched(`purchaseOrderItems.${index}.productId`, true);
                                      if (newValue?.productCode) {
                                        setFieldValue(`purchaseOrderItems.${index}.productCode`, newValue.productCode);
                                      }
                                    }}
                                    onBlur={() => setFieldTouched(`purchaseOrderItems.${index}.productId`, true)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Product *"
                                        error={Boolean(itemTouched.productId && itemErrors.productId)}
                                        helperText={itemTouched.productId && itemErrors.productId}
                                      />
                                    )}
                                  />
                                  <TextField
                                    label="Product Code *"
                                    name={`purchaseOrderItems.${index}.productCode`}
                                    value={item.productCode || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.productCode && itemErrors.productCode)}
                                    helperText={itemTouched.productCode && itemErrors.productCode}
                                  />
                                  <TextField
                                    label="Product Alias Name *"
                                    name={`purchaseOrderItems.${index}.productAliasName`}
                                    value={item.productAliasName || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.productAliasName && itemErrors.productAliasName)}
                                    helperText={itemTouched.productAliasName && itemErrors.productAliasName || "Product Alias"}
                                    placeholder="e.g., Summer Collection Sneakers"
                                  />
                                  {/* <Autocomplete
                                    options={colorOptions}
                                    getOptionLabel={(o) => o.label}
                                    value={colorOptions.find((o) => o.value === item.colorId) || null}
                                    onChange={(_, newValue) => {
                                      setFieldValue(`purchaseOrderItems.${index}.colorId`, newValue?.value || "");
                                      setFieldTouched(`purchaseOrderItems.${index}.colorId`, true);
                                    }}
                                    onBlur={() => setFieldTouched(`purchaseOrderItems.${index}.colorId`, true)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Color *"
                                        error={Boolean(itemTouched.colorId && itemErrors.colorId)}
                                        helperText={itemTouched.colorId && itemErrors.colorId}
                                      />
                                    )}
                                  /> */}
                                </>
                              )}
                              {/* 
                             <Autocomplete
                                    options={vendorOptions.filter(v => {
                                      if (orderMode === "warehouse") {
                                        return v.isInternal === 0;
                                      } else {
                                        if (isSourceWarehouse) {
                                          return v.isInternal === 1;
                                        } else {
                                          return v.isInternal === 0;
                                        }
                                      }
                                    })}                                  
                                    getOptionLabel={(o) => o.label}
                                    value={vendorOptions.find((o) => String(o.value) === String(item.vendorId)) || null}
                                    onChange={(_, newValue) => {
                                      const vendorValue = newValue?.value || "";
                                      
                                      if (isFirstItem || !isSourceVendorLocked) {
                                        handleVendorSelection(vendorValue, setFieldValue, index);
                                      } else {
                                        // For non-first items when locked, still update the field
                                        setFieldValue(`purchaseOrderItems.${index}.vendorId`, vendorValue);
                                      }
                                    }}
                                    onBlur={() => {
                                      setFieldTouched(`purchaseOrderItems.${index}.vendorId`, true);
                                    }}
                                    disabled={!isFirstItem && isSourceVendorLocked}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Vendor *"
                                        error={Boolean(itemTouched.vendorId && itemErrors.vendorId)}
                                        helperText={
                                          itemTouched.vendorId && itemErrors.vendorId ||
                                          (!isFirstItem && isSourceVendorLocked ? "Locked to first item's selection" : "")
                                        }
                                        InputProps={{
                                          ...params.InputProps,
                                          readOnly: !isFirstItem && isSourceVendorLocked,
                                        }}
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) => {
                                      if (!option && !value) return true;
                                      if (!option || !value) return false;
                                      // Use String comparison to avoid type issues
                                      return String(option.value) === String(value.value);
                                    }}
                                    renderOption={(props, option) => (
                                      <Box component="li" {...props}>
                                        <Typography variant="body1">
                                          {option.label}
                                        </Typography>
                                      </Box>
                                    )}
                                  /> */}
                              {/* <Autocomplete
                                    options={vendorOptions.filter(v => {
                                      if (orderMode === "warehouse") {
                                        return v.isInternal === 0;
                                      } else {
                                        if (isSourceWarehouse) {
                                          return v.isInternal === 1;
                                        } else {
                                          return v.isInternal === 0;
                                        }
                                      }
                                    })}                                  
                                    getOptionLabel={(o) => o.label}
                                    value={vendorOptions.find((o) => String(o.value) === String(item.vendorId)) || null}
                                    onChange={(_, newValue) => {
                                      const vendorValue = newValue?.value || "";
                                    }}
                                    onBlur={() => setFieldTouched(`purchaseOrderItems.${index}.vendorId`, true)}
                                    disabled={index !== 0} // Allow only first item to change when locked
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Vendor *"
                                        error={Boolean(itemTouched.vendorId && itemErrors.vendorId)}
                                        helperText={
                                          itemTouched.vendorId && itemErrors.vendorId ||
                                          (index !== 0 ? "Vendor locked - change in first item" : "")
                                        }
                                        InputProps={{
                                          ...params.InputProps,
                                          readOnly: index !== 0,
                                        }}
                                      />
                                    )}
                                  /> */}
                              {/* <TextField
                                  label="Vendor Comments"
                                  name={`purchaseOrderItems.${index}.vendorComments`}
                                  value={item.vendorComments || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Optional notes for vendor"
                                /> */}


                              <Autocomplete
                                options={uomOptions}
                                getOptionLabel={(o) => o.label}
                                value={uomOptions.find((o) => o.value === item.uomId) || null}
                                onChange={(_, newValue) => {
                                  setFieldValue(`purchaseOrderItems.${index}.uomId`, newValue?.value || "");
                                  setFieldTouched(`purchaseOrderItems.${index}.uomId`, true);
                                }}
                                onBlur={() => setFieldTouched(`purchaseOrderItems.${index}.uomId`, true)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Unit of Measure *"
                                    error={Boolean(itemTouched.uomId && itemErrors.uomId)}
                                    helperText={itemTouched.uomId && itemErrors.uomId}
                                  />
                                )}
                              />
                            </Box>
                          </Box>

                          {/* Size Range (Warehouse Only) */}
                          {isWarehouse && (
                            <>
                              <Divider sx={{ mb: 3 }} />
                              <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle2" color="primary" fontWeight="600" gutterBottom>
                                  Size Range
                                </Typography>
                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
                                    gap: 2,
                                  }}
                                >
                                  <TextField
                                    label="Min Size *"
                                    name={`purchaseOrderItems.${index}.minShoeSize`}
                                    value={item.minShoeSize || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.minShoeSize && itemErrors.minShoeSize)}
                                    helperText={
                                      itemTouched.minShoeSize && itemErrors.minShoeSize
                                        ? itemErrors.minShoeSize
                                        : ''
                                    }
                                    type="number"
                                    inputProps={{ step: "0.5", title: "Enter a valid  size" }}
                                  />
                                  <TextField
                                    label="Max  Size *"
                                    name={`purchaseOrderItems.${index}.maxShoeSize`}
                                    value={item.maxShoeSize || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.maxShoeSize && itemErrors.maxShoeSize)}
                                    helperText={
                                      itemTouched.maxShoeSize && itemErrors.maxShoeSize
                                        ? itemErrors.maxShoeSize
                                        : ''
                                    }
                                    type="number"
                                    inputProps={{ step: "0.5", title: "Enter a valid  size" }}
                                  />
                                </Box>
                              </Box>
                            </>
                          )}
                          {/* ✅ CORRECT: Move Size Range outside the Product Information grid */}
                          {orderMode === "retail" && !isSourceWarehouse && (
                            <>
                              <Divider sx={{ mb: 3 }} />
                              <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle2" color="primary" fontWeight="600" gutterBottom>
                                  Size Range
                                </Typography>
                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
                                    gap: 2,
                                  }}
                                >
                                  <TextField
                                    label="Min Size"
                                    name={`purchaseOrderItems.${index}.minShoeSize`}
                                    value={item.minShoeSize || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.minShoeSize && itemErrors.minShoeSize)}
                                    helperText={
                                      itemTouched.minShoeSize && itemErrors.minShoeSize
                                        ? itemErrors.minShoeSize
                                        : ''
                                    }
                                    type="number"
                                    inputProps={{ step: "0.5", title: "Enter a valid shoe size" }}
                                  />
                                  <TextField
                                    label="Max Size"
                                    name={`purchaseOrderItems.${index}.maxShoeSize`}
                                    value={item.maxShoeSize || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.maxShoeSize && itemErrors.maxShoeSize)}
                                    helperText={
                                      itemTouched.maxShoeSize && itemErrors.maxShoeSize
                                        ? itemErrors.maxShoeSize
                                        : ''
                                    }
                                    type="number"
                                    inputProps={{ step: "0.5", title: "Enter a valid size" }}
                                  />
                                </Box>
                              </Box>
                            </>
                          )}


                          {/* Inventory & Pricing */}
                          <Divider sx={{ mb: 3 }} />
                          <Box>
                            <Typography variant="subtitle2" color="primary" fontWeight="600" gutterBottom>
                              Quantity & Pricing
                            </Typography>
                            <Box
                              sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                  xs: "1fr",
                                  sm: "repeat(2, 1fr)",
                                  md: "repeat(3, 1fr)",
                                },
                                gap: 2,
                              }}
                            >
                              <TextField
                                label="Cartons *"
                                name={`purchaseOrderItems.${index}.cartons`}
                                value={item.cartons || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={Boolean(itemTouched.cartons && itemErrors.cartons)}
                                helperText={
                                  (itemTouched.cartons && itemErrors.cartons) ||
                                  (orderMode === "retail" && item.cartonsAvailable !== undefined && isSourceWarehouse
                                    ? `Available: ${item.cartonsAvailable} cartons`
                                    : isSourceWarehouse === false
                                      ? "External source - no stock limit"
                                      : !values.globalSource
                                        ? "Select a source first"
                                        : "")
                                }
                                type="number"
                                inputProps={{
                                  min: 1,
                                  max: orderMode === "retail" && item.cartonsAvailable !== undefined && isSourceWarehouse ? item.cartonsAvailable : undefined,
                                  step: 1
                                }}
                              />
                              <TextField
                                label="Quantity per Carton *"
                                name={`purchaseOrderItems.${index}.quantityPerCarton`}
                                value={item.quantityPerCarton || ""}
                                onChange={(e) => {
                                  handleChange(e);
                                  // Recalculate carton prices if pair prices exist
                                  if (orderMode === "warehouse") {
                                    if (item.buyingPricePerPair) {
                                      const cartonPrice = calculateCartonPrice(item.buyingPricePerPair, e.target.value);
                                      setFieldValue(`purchaseOrderItems.${index}.buyingPricePerCarton`, cartonPrice);
                                    }
                                    if (item.sellingPricePerPair) {
                                      const cartonPrice = calculateCartonPrice(item.sellingPricePerPair, e.target.value);
                                      setFieldValue(`purchaseOrderItems.${index}.sellingPricePerCarton`, cartonPrice);
                                    }
                                  }
                                }}
                                onBlur={handleBlur}
                                error={Boolean(itemTouched.quantityPerCarton && itemErrors.quantityPerCarton)}
                                helperText={itemTouched.quantityPerCarton && itemErrors.quantityPerCarton}
                                type="number"
                                inputProps={{ min: 1, step: 1 }}
                              />

                              {orderMode === "warehouse" ? (
                                <>
                                  <TextField
                                    label="Buying Price/Pair"
                                    name={`purchaseOrderItems.${index}.buyingPricePerPair`}
                                    value={item.buyingPricePerPair || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      // Auto-calculate carton price when pair price changes
                                      const pairPrice = e.target.value;
                                      const quantity = item.quantityPerCarton;
                                      if (pairPrice && quantity) {
                                        const cartonPrice = calculateCartonPrice(pairPrice, quantity);
                                        setFieldValue(`purchaseOrderItems.${index}.buyingPricePerCarton`, cartonPrice);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                    helperText="Enter price per pair to auto-calculate carton price"
                                    type="number"
                                    inputProps={{ min: 0, step: 0.01 }}
                                  />
                                  <TextField
                                    label="Buying Price/Carton *"
                                    name={`purchaseOrderItems.${index}.buyingPricePerCarton`}
                                    value={item.buyingPricePerCarton || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      // Also allow manual entry and clear auto-calculated pair price
                                      setFieldValue(`purchaseOrderItems.${index}.buyingPricePerPair`, "");
                                    }}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.buyingPricePerCarton && itemErrors.buyingPricePerCarton)}
                                    helperText={itemTouched.buyingPricePerCarton && itemErrors.buyingPricePerCarton}
                                    type="number"
                                    inputProps={{ min: 0, step: 0.01 }}
                                  />
                                  <TextField
                                    label="Selling Price/Pair"
                                    name={`purchaseOrderItems.${index}.sellingPricePerPair`}
                                    value={item.sellingPricePerPair || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      // Auto-calculate carton price when pair price changes
                                      const pairPrice = e.target.value;
                                      const quantity = item.quantityPerCarton;
                                      if (pairPrice && quantity) {
                                        const cartonPrice = calculateCartonPrice(pairPrice, quantity);
                                        setFieldValue(`purchaseOrderItems.${index}.sellingPricePerCarton`, cartonPrice);
                                      }
                                    }}
                                    onBlur={handleBlur}
                                    helperText="Enter price per pair to auto-calculate carton price"
                                    type="number"
                                    inputProps={{ min: 0, step: 0.01 }}
                                  />
                                  <TextField
                                    label="Selling Price/Carton *"
                                    name={`purchaseOrderItems.${index}.sellingPricePerCarton`}
                                    value={item.sellingPricePerCarton || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      // Also allow manual entry and clear auto-calculated pair price
                                      setFieldValue(`purchaseOrderItems.${index}.sellingPricePerPair`, "");
                                    }}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.sellingPricePerCarton && itemErrors.sellingPricePerCarton)}
                                    helperText={itemTouched.sellingPricePerCarton && itemErrors.sellingPricePerCarton}
                                    type="number"
                                    inputProps={{ min: 0, step: 0.01 }}
                                  />
                                </>
                              ) : (
                                <>
                                  <TextField
                                    label="Buying Price/Pair *"
                                    name={`purchaseOrderItems.${index}.buyingPricePerPair`}
                                    value={item.buyingPricePerPair || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.buyingPricePerPair && itemErrors.buyingPricePerPair)}
                                    helperText={itemTouched.buyingPricePerPair && itemErrors.buyingPricePerPair}
                                    type="number"
                                    inputProps={{ min: 0, step: 0.01 }}
                                  />
                                  <TextField
                                    label="Buying Price/Carton"
                                    value={
                                      item.cartons && item.quantityPerCarton && item.buyingPricePerPair
                                        ? (item.quantityPerCarton * item.buyingPricePerPair).toFixed(2)
                                        : "0.00"
                                    }
                                    disabled
                                    InputProps={{ readOnly: true }}
                                    helperText="Auto-calculated"
                                  />
                                  <TextField
                                    label="Selling Price/Pair *"
                                    name={`purchaseOrderItems.${index}.sellingPricePerPair`}
                                    value={item.sellingPricePerPair || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={Boolean(itemTouched.sellingPricePerPair && itemErrors.sellingPricePerPair)}
                                    helperText={itemTouched.sellingPricePerPair && itemErrors.sellingPricePerPair}
                                    type="number"
                                    inputProps={{ min: 0, step: 0.01 }}
                                  />
                                  <TextField
                                    label="Selling Price/Carton"
                                    value={
                                      item.cartons && item.quantityPerCarton && item.sellingPricePerPair
                                        ? (item.quantityPerCarton * item.sellingPricePerPair).toFixed(2)
                                        : "0.00"
                                    }
                                    disabled
                                    InputProps={{ readOnly: true }}
                                    helperText="Auto-calculated"
                                  />
                                </>
                              )}
                              <TextField
                                label={
                                  orderMode === "retail"
                                    ? "Reorder Point (Pairs) *"
                                    : `Reorder Point ${getUomNameById(item.uomId)} *`
                                }
                                name={`purchaseOrderItems.${index}.reorderPoint`}
                                value={item.reorderPoint || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={Boolean(itemTouched.reorderPoint && itemErrors.reorderPoint)}
                                helperText={itemTouched.reorderPoint && itemErrors.reorderPoint}
                                type="number"
                                inputProps={{ min: 0 }}
                              />
                               <TextField
                                label="Date Purchased *"
                                name={`purchaseOrderItems.${index}.createdDate`}
                                value={item.createdDate || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={Boolean(itemTouched.createdDate && itemErrors.createdDate)}
                                helperText={itemTouched.createdDate && itemErrors.createdDate}
                                type="date"
                                InputLabelProps={{ shrink: true }}
                              />
                              <TextField
                                label="Stock Due Date *"
                                name={`purchaseOrderItems.${index}.stockDueDate`}
                                value={item.stockDueDate || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={Boolean(itemTouched.stockDueDate && itemErrors.stockDueDate)}
                                helperText={itemTouched.stockDueDate && itemErrors.stockDueDate}
                                type="date"
                                InputLabelProps={{ shrink: true }}
                              />
                             
                            </Box>
                          </Box>

                          {/* Stock Warning for Retail */}
                          {orderMode === "retail" && item.cartonsAvailable !== undefined && isSourceWarehouse && (
                            <Alert severity="info" sx={{ mt: 2 }}>
                              Available stock: <strong>{item.cartonsAvailable} cartons</strong>
                            </Alert>
                          )}
                        </Paper>
                      );
                    })}

                    {/* Add Item Button */}
                    <Button
                      variant="outlined"
                      size="large"
                      onClick={() => {

                        const newItem = {
                          warehouseInventoryId: "",
                          productId: "",
                          productName: "",
                          // vendorId: globalVendor || "", // Use global vendor
                          // vendorBranchId: globalSource || "", // Use global source for retail
                          productCode: "",
                          productAliasName: "",
                          isProductSelected: false, // Add this flag - false means fields are enabled
                          // vendorComments: globalVendorComments || "", // Use global comments
                          colorId: "",
                          uomId: "",
                          cartons: "",
                          cartonsAvailable: "",
                          quantityPerCarton: "",
                          minShoeSize: "",
                          maxShoeSize: "",
                          buyingPricePerCarton: "",
                          sellingPricePerCarton: "",
                          buyingPricePerPair: "",
                          sellingPricePerPair: "",
                          reorderPoint: "",
                          stockDueDate: "",
                          createdDate: getTodayLocalDate(),
                          // Set vendorBranchId from global source for retail mode
                          vendorBranchId: orderMode === "retail" ? values.globalSource : "",
                          // Set vendorId from global vendor
                          vendorId: values.globalVendor || "",
                          // Set vendorComments from global comments
                          vendorComments: values.globalVendorComments || "",
                        };

                        arrayHelpers.push(newItem);
                      }}
                      sx={{ mb: 3, width: "100%" }}
                    >
                      + Add Item
                    </Button>
                  </Box>
                )}
              />

              {/* Form Actions */}
              <Paper elevation={2} sx={{ p: 3, position: "sticky", bottom: 0, backgroundColor: "background.paper" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    {values.purchaseOrderItems.length} item(s) in order
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Button variant="outlined" onClick={props.onClose} disabled={isSubmitting}>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      size="large"
                      disabled={isSubmitting || values.purchaseOrderItems.length === 0}
                      startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
                    >
                      {isSubmitting ? "Submitting..." : "Submit Order"}
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default PurchaseOrderForm;
